import { useContext } from 'react';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import LatestPaymentObligationsList from './LatestPaymentObligationsList';
import i18nContext from 'components/i18n-context';
import { NewContainer } from 'uikit/NewContainer/NewContainer';
import './LatestPaymentObligations.scss';

const LatestPaymentObligations = ({ paymentObligationsStore }) => {
  const i18n = useContext(i18nContext);

  return (
    <section className={'page-container latest-payment-obligations'}>
      <NewContainer
        className={'payment-obligations-container content-card-wrapper'}
        header={i18n.getMessage('container.paymentObligations')}
      >
        <LatestPaymentObligationsList
          obligations={paymentObligationsStore?.obligationList}
          isLoading={paymentObligationsStore.isLoading}
        />
      </NewContainer>
    </section>
  );
};

LatestPaymentObligations.propTypes = {
  paymentObligationsStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  paymentObligationsStore: stores.paymentObligationsStore
}))(observer(LatestPaymentObligations));
